module.exports = __webpack_public_path__ + "media/images/png/rent/2-39abee1815e18929340439df60bf41fc.png";